import type React from "react";
import { StyledInfoSection } from "./style";
import { SanitizedHTML } from "../../utils/sanitizedHtml";
import { translateIfPresent } from "../../locales/i18n";
import { StyledHelpText } from "../CaptionBlock/styles";
import { Icon, Text } from "@smartsuite/react-ui/lib";
import { Colors, GrayColors, TextColorNames } from "@smartsuite/types";
import type { Info } from "@smartsuite/automation-engine-api";
import { Details_DetailsType } from "@smartsuite/automation-engine-api";

export const InfoSection: React.FC<{ info: Info }> = ({ info }) => {
  const detailsType = info.details?.type ?? Details_DetailsType.INFO;

  return (
    <StyledInfoSection detailsType={detailsType}>
      <div className={"info-left-side"}>{getIcon(detailsType)}</div>
      <div className={"info-right-side"}>
        {info?.details?.title && (
          <Text size={"m"} weight={"medium"} color={TextColorNames.primary}>
            {info.details.title &&
              translateIfPresent(
                `caption.${info.details.title}`,
                info.details.title,
              )}
          </Text>
        )}
        {info?.details?.description && (
          <StyledHelpText>
            <Text size={"s"} color="secondary">
              <SanitizedHTML
                html={translateIfPresent(
                  `caption.${info.details.description}`,
                  info.details.description,
                )}
                options={{
                  allowedTags: ["span", "p", "b", "a", "br", "div"],
                  allowedAttributes: {
                    a: ["href", "target"],
                    span: ["style"],
                  },
                }}
              />
            </Text>
          </StyledHelpText>
        )}
      </div>
    </StyledInfoSection>
  );
};

const getIcon = (detailsType: Details_DetailsType): React.JSX.Element => {
  switch (detailsType) {
    case Details_DetailsType.ERROR:
    case Details_DetailsType.WARNING: {
      return (
        <Icon
          name={"alert"}
          size="S"
          style={{ height: "16px", width: "16px", fill: Colors.bRed }}
        />
      );
    }
    case Details_DetailsType.INFO:
    default: {
      return (
        <Icon
          name={"info-filled"}
          size="S"
          style={{ height: "16px", width: "16px", fill: GrayColors["G-4"] }}
        />
      );
    }
  }
};
